export const NOTIFICATIONS_LIST_STORE = 'notificationsListStore'
export const UNSCHEDULED_JOBS_LIST_STORE = 'unscheduledJobsListStore'
export const JOBS_LIST_STORE = 'jobsListStore'
export const TEMPLATES_LIST_STORE = 'templatesListStore'
export const VEHICLES_LIST_STORE = 'vehiclesListStore'
export const MACHINE_LIST_STORE = 'machineListStore'
export const ASSETS_LIST_STORE = 'assetsListStore'
export const ASSET_VEHICLES_LIST_STORE = 'assetVehiclesListStore'
export const ASSET_EQUIPMENTS_LIST_STORE = 'assetEquipmentsListStore'
export const WORK_ORDERS_LIST_STORE = 'workOrdersListStore'
export const MILL_ORDERS_LIST_STORE = 'millOrdersListStore'
export const VENDORS_LIST_STORE = 'vendorsListStore'
export const EQUIPMENTS_LIST_STORE = 'equipmentsListStore'
export const SERVICE_PROGRAMMES_LIST_STORE = 'serviceProgrammesListStore'
export const JOB_SCHEDULES_LIST_STORE = 'jobSchedulesListStore'
export const INSPECTIONS_LIST_STORE = 'inspectionsListStore'
export const ISSUES_LIST_STORE = 'issuesListStore'
export const VEHICLE_FUEL_HISTORY_LIST_STORE = 'vehicleFuelHistoryListStore'
export const VEHICLE_METER_HISTORY_LIST_STORE = 'vehicleMeterHistoryListStore'
export const MACHINE_FUEL_HISTORY_LIST_STORE = 'machineFuelHistoryListStore'
export const MACHINE_METER_HISTORY_LIST_STORE = 'machineMeterHistoryListStore'
export const EMPLOYEES_LIST_STORE = 'employeesListStore'
export const SERVICES_LIST_STORE = 'servicesListStore'
export const SERVICE_TASKS_LIST_STORE = 'serviceTasksListStore'
export const MAINTENANCE_ISSUES_LIST_STORE = 'maintenanceIssuesListStore'
export const EQUIPMENT_MACHINE_HOURS_LIST_STORE = 'equipmentMachineHoursListStore'
export const JOB_SCHEDULE_LIST_STORE = 'jobScheduleListStore'

export const EMPLOYEE_TO_ASSIGN_LIST_STORE = 'employeesToAssignListStore'
export const EMPLOYEE_TO_DELIVER_LIST_STORE = 'employeesToDeliverListStore'
export const VENDOR_TO_ASSIGN_LIST_STORE = 'vendorsToAssignListStore'
export const ISSUE_REPORTER_LIST_STORE = 'issueReportedListStore'
export const TEMPLATE_SELECTION_LIST_STORE = 'templateSelectionListStore'
export const TASK_TEMPLATE_SELECTION_STORE = 'taskTemplateSelectionStore'
export const ASSET_CATEGORY_FILTER_STORE = 'assetCategoryFilterStore'
export const ASSET_FILTER_STORE = 'assetFilterStore'

// jobs list filter stores
export const JOBS_LIST_TYPE_FILTER_STORE = 'jobsListTypeFilterStore'
export const JOBS_LIST_PRIORITY_FILTER_STORE = 'jobsListPriorityFilterStore'
export const JOBS_LIST_STATUS_FILTER_STORE = 'jobsListStatusFilterStore'
export const JOBS_LIST_ASSIGNEE_FILTER_STORE = 'jobsListAssigneeFilterStore'

// templates list filter stores
export const TEMPLATES_LIST_TYPE_FILTER_STORE = 'templatesListTypeFilterStore'

// work orders list filter stores
export const WORK_ORDERS_LIST_STATUS_FILTER_STORE = 'workOrdersListStatusFilterStore'
export const WORK_ORDERS_LIST_PRIORITY_FILTER_STORE = 'workOrdersListPriorityFilterStore'
export const WORK_ORDERS_LIST_ASSIGNEE_FILTER_STORE = 'workOrdersListAssigneeFilterStore'
export const WORK_ORDERS_LIST_SCHEDULED_DATE = 'workOrdersListScheduledDate'
export const WORK_ORDERS_LIST_DUE_DATE = 'workOrdersListDueDate'
export const WORK_ORDERS_LIST_COMPLETED_DATE = 'workOrdersListCompletedDate'
export const WORK_ORDERS_LIST_VENDOR_FILTER_STORE = 'workOrdersListVendorFilterStore'

// mill orders list filter stores
export const MILL_ORDERS_LIST_STATUS_FILTER_STORE = 'millOrdersListStatusFilterStore'
export const MILL_ORDERS_LIST_PRIORITY_FILTER_STORE = 'millOrdersListPriorityFilterStore'
export const MILL_ORDERS_LIST_ASSIGNEE_FILTER_STORE = 'millOrdersListAssigneeFilterStore'
export const MILL_ORDERS_LIST_DUE_DATE_FILTER_STORE = 'millOrdersListDueDateFilterStore'
export const MILL_ORDERS_LIST_COMPLETED_DATE_FILTER_STORE = 'millOrdersListCompletedDateFilterStore'

// services list filter stores
export const SERVICES_LIST_STATUS_FILTER_STORE = 'servicesListStatusFilterStore'
export const SERVICES_LIST_PRIORITY_FILTER_STORE = 'servicesListPriorityFilterStore'
export const SERVICES_LIST_ASSIGNEE_FILTER_STORE = 'servicesListAssigneeFilterStore'
export const SERVICES_LIST_SCHEDULED_DATE_FILTER_STORE = 'servicesListScheduledDateFilterStore'
export const SERVICES_LIST_DUE_DATE_FILTER_STORE = 'servicesListDueDateFilterStore'
export const SERVICES_LIST_COMPLETED_DATE_FILTER_STORE = 'servicesListCompletedDateFilterStore'
export const SERVICES_LIST_ASSET_CATEGORY_FILTER_STORE = 'servicesListAssetCategoryFilterStore'
export const SERVICES_LIST_ASSET_FILTER_STORE = 'servicesListAssetFilterStore'

// service programmes list filter stores
export const SERVICE_PROGRAMMES_LIST_TYPE_FILTER_STORE = 'serviceProgrammesListTypeFilterStore'
export const SERVICE_PROGRAMMES_LIST_PRIORITY_FILTER_STORE =
  'serviceProgrammesListPriorityFilterStore'
export const SERVICE_PROGRAMMES_LIST_ASSET_CATEGORY_FILTER_STORE =
  'serviceProgrammesListAssetCategoryFilterStore'
export const SERVICE_PROGRAMMES_LIST_ASSET_FILTER_STORE = 'serviceProgrammesListAssetFilterStore'
export const SERVICE_PROGRAMMES_LIST_SERVICE_TASK_FILTER_STORE =
  'serviceProgrammesListServiceTaskFilterStore'
export const SERVICE_PROGRAMMES_LIST_ASSIGNEE_FILTER_STORE =
  'serviceProgrammesListAssigneeFilterStore'

// service tasks list filter stores
export const SERVICE_TASKS_LIST_ASSET_CATEGORY_FILTER_STORE =
  'serviceTasksListAssetCategoryFilterStore'

// inspections list filter stores
export const INSPECTIONS_LIST_STATUS_FILTER_STORE = 'inspectionsListStatusFilterStore'
export const INSPECTIONS_LIST_PRIORITY_FILTER_STORE = 'inspectionsListPriorityFilterStore'
export const INSPECTIONS_LIST_SCHEDULED_DATE_FILTER_STORE =
  'inspectionsListScheduledDateFilterStore'
export const INSPECTIONS_LIST_DUE_DATE_FILTER_STORE = 'inspectionsListDueDateFilterStore'
export const INSPECTIONS_LIST_COMPLETED_DATE_FILTER_STORE =
  'inspectionsListCompletedDateFilterStore'
export const INSPECTIONS_LIST_ASSIGNEE_FILTER_STORE = 'inspectionsListAssigneeFilterStore'
export const INSPECTIONS_LIST_VENDOR_FILTER_STORE = 'inspectionsListVendorFilterStore'

// issues list filter stores
export const ISSUES_LIST_STATUS_FILTER_STORE = 'issuesListStatusFilterStore'
export const ISSUES_LIST_PRIORITY_FILTER_STORE = 'issuesListPriorityFilterStore'
export const ISSUES_LIST_ASSIGNEE_FILTER_STORE = 'issuesListAssigneeFilterStore'
export const ISSUES_LIST_REPORTER_FILTER_STORE = 'issuesListReporterFilterStore'
export const ISSUES_LIST_SCHEDULED_DATE_FILTER_STORE = 'issuesListScheduledDateFilterStore'
export const ISSUES_LIST_REPORTED_DATE_FILTER_STORE = 'issuesListReportedDateFilterStore'
export const ISSUES_LIST_COMPLETED_DATE_FILTER_STORE = 'issuesListCompletedDateFilterStore'

// vendors list filter stores
export const VENDORS_LIST_CATEGORY_FILTER_STORE = 'vendorsListCategoryFilterStore'

// vehicles list filter stores
export const VEHICLES_LIST_TYPE_FILTER_STORE = 'vehiclesListTypeFilterStore'
export const VEHICLES_LIST_YEAR_FILTER_STORE = 'vehiclesListYearFilterStore'
export const VEHICLES_LIST_MODEL_FILTER_STORE = 'vehiclesListModelFilterStore'
export const VEHICLES_LIST_STATUS_FILTER_STORE = 'vehiclesListStatusFilterStore'
export const VEHICLES_LIST_ASSIGNEE_FILTER_STORE = 'vehiclesListAssigneeFilterStore'
export const VEHICLES_LIST_OWNERSHIP_FILTER_STORE = 'vehiclesListOwnershipFilterStore'
export const VEHICLES_LIST_COMMISSION_DATE_FILTER_STORE = 'vehiclesListCommissionDateFilterStore'
export const VEHICLES_LIST_DECOMMISSION_DATE_FILTER_STORE =
  'vehiclesListDecommissionDateFilterStore'

// machine list filter stores
export const MACHINE_LIST_TYPE_FILTER_STORE = 'machineListTypeFilterStore'
export const MACHINE_LIST_YEAR_FILTER_STORE = 'machineListYearFilterStore'
export const MACHINE_LIST_MODEL_FILTER_STORE = 'machineListModelFilterStore'
export const MACHINE_LIST_STATUS_FILTER_STORE = 'machineListStatusFilterStore'
export const MACHINE_LIST_ASSIGNEE_FILTER_STORE = 'machineListAssigneeFilterStore'
export const MACHINE_LIST_OWNERSHIP_FILTER_STORE = 'machineListOwnershipFilterStore'
export const MACHINE_LIST_COMMISSION_DATE_FILTER_STORE = 'machineListCommissionDateFilterStore'
export const MACHINE_LIST_DECOMMISSION_DATE_FILTER_STORE = 'machineListDecommissionDateFilterStore'

// equipments list filter stores
export const EQUIPMENTS_LIST_TYPE_FILTER_STORE = 'equipmentsListTypeFilterStore'
export const EQUIPMENTS_LIST_STATUS_FILTER_STORE = 'equipmentsListStatusFilterStore'
export const EQUIPMENTS_LIST_ASSIGNEE_FILTER_STORE = 'equipmentsListAssigneeFilterStore'
export const EQUIPMENTS_LIST_OWNERSHIP_FILTER_STORE = 'equipmentsListOwnershipFilterStore'
export const EQUIPMENTS_LIST_YEAR_FILTER_STORE = 'equipmentsListYearFilterStore'

// jobs schedules list filter stores
export const JOBS_SCHEDULES_LIST_TYPE_FILTER_STORE = 'jobsSchedulesListTypeFilterStore'
export const JOBS_SCHEDULES_LIST_PRIORITY_FILTER_STORE = 'jobsSchedulesListPriorityFilterStore'
export const JOBS_SCHEDULES_LIST_ASSIGNEE_FILTER_STORE = 'jobsSchedulesListAssigneeFilterStore'
export const JOBS_SCHEDULES_LIST_WORK_ORDER_VENDOR_FILTER_STORE =
  'jobsSchedulesListWorkOrderVendorFilterStore'
